import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { getIdentifier } from "./utils/auth";
import { AuthProvider } from "./auth/useAuth"; // ← JS version: useAuth.jsx

getIdentifier(); // hydrate sessionStorage from localStorage if present

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
); 

reportWebVitals();
